<template>
    <div class="p-2 flex flex-col sm:flex-row gap-4 border border-b-0" data-testid="search-part-header">
        <div class="flex-none">
            <NuxtLink v-if="result.Url" :to="result.Url" :aria-label="result.PartNumber">
                <PartImage size="md" :image-url="result.ImageUrl" :alt="result.PartNumber" />
            </NuxtLink>
            <PartImage v-else size="md" :image-url="result.ImageUrl" :alt="result.PartNumber" />
        </div>
        <div class="lg:flex-none lg:w-2/5 flex flex-col gap-2 overflow-clip">
            <h2 class="my-0">
                <div class="text-lg" data-testid="search-part-header-mfg">{{ result.Manufacturer?.Name }}</div>
                <div data-testid="search-part-header-part-num">
                    <NuxtLink v-if="result.Url" :to="result.Url">{{ result.PartNumber }}</NuxtLink>
                    <template v-else>{{ result.PartNumber }}</template>
                </div>
            </h2>
            <div class="flex flex-wrap gap-2 min-h-6">
                <PartLifecycleRisk :risk="result.LifecycleRisk" />
                <PartSupplyChainRisk :risk="result.SupplyChainRisk" />
                <PartTariff :result />
            </div>
            <div class="flex flex-wrap gap-2 items-center">
                <slot name="actions"></slot>
                <PartModelsLink
                    v-if="result.Manufacturer && result.Url"
                    :href="modelsUrl"
                    :manufacturer="result.Manufacturer.VirtualPath"
                    :part-number="result.PartNumber" />
            </div>
        </div>
        <div class="text-right flex-1 hidden md:block">
            <div v-if="result.CategoryHierarchy" class="leading-relaxed mb-2" data-testid="category-hierarchy">
                <template v-for="(cat, index) in categories" :key="cat.Url">
                    <Icon v-if="index > 0" name="chevron-right" class="px-1" />
                    <NuxtLink :to="cat.Url" class="">{{ cat.Name }}</NuxtLink>
                </template>
            </div>
            <div>{{ result.Description }}</div>
        </div>
        <slot name="chart"></slot>
    </div>
</template>
<script setup lang="ts">
const MIN_CAT_COUNT = 2;
const MAX_CAT_NAME_LENGTH = 80;

const { result } = defineProps<{
    result: PartDetailResultTransformed;
}>();

const modelsUrl = computed(() => result.Url + "/models");

const categories = computed(() => {
    const output = [...result.CategoryHierarchy];
    let totalLen = output.reduce((subtotal, cat) => subtotal + cat.Name.length, 0);
    while (output.length > MIN_CAT_COUNT && totalLen > MAX_CAT_NAME_LENGTH) {
        const removed = output.shift();
        if (removed) totalLen -= removed.Name.length;
    }
    return output;
});
</script>
